export default 'Press delete or backspace to remove';